"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OPENED_OFFER_ID_PARAM_NAME = exports.OFFER_ACTIONS = void 0;
var OFFER_ACTIONS = exports.OFFER_ACTIONS = {
  ADD_TO_BASKET: 'add_to_basket',
  SAVE_TO_ORDER: 'save_to_order',
  COPY_TO_BUFFER: 'copy_to_buffer',
  COPY_URL_TO_BUFFER: 'copy_url_to_buffer'
};
var OPENED_OFFER_ID_PARAM_NAME = exports.OPENED_OFFER_ID_PARAM_NAME = 'openedOfferID';